import { footerTranslation } from '@/assets/locales/layouts/footer/footer.translation.pl.ts';

import { LayoutsTranslation } from './layouts.translation.en';

export const layoutsTranslation: LayoutsTranslation = {
  environmentBanner: {
    dev: {
      description: 'Środowisko deweloperskie, które może być niestabilne.',
      title: 'Środowisko deweloperskie',
    },
    preview: {
      description:
        'Środowisko przedwdrożeniowe, możliwie podobne do prod z ewentualnymi poprawkami lub ostatecznymi testami nowych funkcjonalności.',
      title: 'Środowisko przedwdrożeniowe',
    },
  },
  footer: footerTranslation,
  logout: {
    tooltip: 'Wyloguj',
  },
};
